export const authUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/api/login'
export const signupUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/api/signup'
export const loginUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/login'


//-------for localhost-------------
//export const authUrl = '/api/login'
//export const signupUrl = '/api/signup'
//export const loginUrl = '/login'
// export const loginUrl = 'https://stage.xsocks.pro/login'